<div class="success-dialog-content">
  <div class="success-icon">
   <img src="../../../../assets/images/success.png" alt="success">
  </div>
  <p class="msg">{{ data.msg }}</p>
</div>
